module.exports = __webpack_public_path__ + "static/img/noContent.b6af562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noContent.png
// module id = eWL0
// module chunks = 0